"use strict";

exports.__esModule = true;
exports.modulusPositive = exports.lerp = exports.easeOut = exports.closestDividend = void 0;
// Cubic ease-out funciton
var easeOut = exports.easeOut = function easeOut(t) {
  return Math.pow(t - 1, 3) + 1;
};

// Linear interpolation
var lerp = exports.lerp = function lerp(start, end, factor) {
  return start * (1 - factor) + end * factor;
};

// Modulus function only returning positive values
var modulusPositive = exports.modulusPositive = function modulusPositive(dividend, divisor) {
  return (dividend % divisor + divisor) % divisor;
};

// The closest index to a value in a looping range
// so value = 4 and index=0 becomes 5 in a 5-length range
var closestDividend = exports.closestDividend = function closestDividend(index, value, length) {
  return [value, value + length, value - length].sort(function (a, b) {
    return Math.abs(a - index) - Math.abs(b - index);
  })[0];
};